// all the values are lowercase because of the field factoty - field without control type - gets by default textbox field.
export enum FieldType {
    ID = 'id',
    CREDIT_CARD_NUMBER = 'credit card number',
    CREDIT_CARD_CVV = 'card cvv'
}
